export const showLogoutInterstitial = () => {
  const modal = document.createElement('div')
  modal.id = 'akc-interstitial'
  modal.innerHTML = `
    <div class="akc-interstitial__box">
      <div class="akc-interstitial__spinner"></div>
      <div class="akc-interstitial__text">Loading...</div>
    </div>
  `
  const style = document.createElement('style')
  style.textContent = `
    #akc-interstitial {
      position: fixed;
      inset: 0;
      background: rgba(0, 60, 150, 0.95);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      opacity: 1;
      transition: opacity .3s ease;
    }
    #akc-interstitial.fade {
      opacity: 0;
      pointer-events: none;
    }
    .akc-interstitial__box {
      text-align: center;
      color: #fff;
      font-family: system-ui, sans-serif;
    }
  `
  document.head.appendChild(style)
  document.body.appendChild(modal)
}

export const hideLogoutInterstitial = () => {
  const modal = document.querySelector('#akc-interstitial')
  if (!modal) return
  modal.classList.add('fade')
  setTimeout(() => modal.remove(), 300)
}

document.addEventListener('click', (e) => {
  const action = e.target.closest('[data-action]')?.dataset.action
  if (action === 'akc-login') window.akc?.getLoginScreenset()
  if (action === 'akc-logout') window.akc?.logout()
})
